import { createContext } from "react"
import { Outlet } from "react-router-dom"

export enum Section {
  ALERTS = "alerts",
  ASSETS = "assets",
  CUSTOMERS = "customers",
  SYSTEMS = "systems",
  DEPLOYMENTS = "deployments",
  ORDERS = "orders",
  FILLING = "filling",
  DASHBOARDS = "dashboards",
  PLANNER = "planner",
  CONNECTIONS = "connections",
}
type ContextState = { route: string; section: Section | undefined }

export const RouteContext = createContext<ContextState | undefined>(undefined)

export const RouteProvider = ({
  children,
  route,
  section,
}: {
  children?: React.ReactNode
  route?: string
  section?: Section
}) => {
  const value = { route: "/" + (route || ""), section: section }

  return <RouteContext.Provider value={value}>{children ? children : <Outlet />}</RouteContext.Provider>
}
